module.exports = __webpack_public_path__ + "static/media/arrow-up-large-inc.efb596ae.svg";